import React, { Fragment } from 'react';
import {
  BrowserRouter,
  Route,
  Switch,
  useHistory,
  useParams,
} from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import './App.css';
import CustomHeader from './components/CustomHeader';
import withAuthentication from './components/withAuthentication';
import AccettaEsercizioCommerciale from './pages/AccettaEsercizioCommerciale.js';
import ConfermaRegistrazione from './pages/ConfermaRegistrazione.jsx';
import ControlPanel from './scenes/controlpanel/ControlPanel';
import DettaglioConsulente from './scenes/controlpanel/dettaglio_consulente/DettaglioConsulente';
import DettaglioEsercizioCommerciale from './scenes/controlpanel/dettaglio_eserciziocommerciale/DettaglioEsercizioCommerciale';
import NuovoEsercizioConsulente from './scenes/controlpanel/dettaglio_eserciziocommerciale/NuovoEsercizioConsulente';
import NuovoEsercizioCommerciale from './scenes/controlpanel/dettaglio_eserciziocommerciale/NuovoEsercizioCommerciale';
import DettaglioManualeSicurezza from './scenes/controlpanel/dettaglio_manuale/DettaglioManualeSicurezza';
import DettaglioResponsabileSicurezza from './scenes/controlpanel/dettaglio_responsabilesicurezza/DettaglioResponsabileSicurezza';
import HomePage from './scenes/home/HomePage';
import LoginPage from './scenes/login/LoginPage';
import LogoutPage from './scenes/logout/LogoutPage';
import PagamentoPage from './scenes/pagamento_abbonamento/PagamentoPage';
import RecoverPswPage from './scenes/resetpsw/RecoverPswPage';
import ResetPswPage from './scenes/resetpsw/ResetPswPage';
import NuovoGruppoPage from './scenes/controlpanel/dettaglio_gruppo/NuovoGruppoPage';
import ModificaGruppoPage from './scenes/controlpanel/dettaglio_gruppo/ModificaGruppoPage';
import RegistraConsulenteGruppoPage from './scenes/controlpanel/dettaglio_consulente/RegistraConsulenteGruppoPage';
import {
  getConsulenteId,
  isSuperconsulente,
  getGruppoId,
} from './utils/storage.js';
import CreazioneNuovoManuale from './scenes/controlpanel/manuale_personalizzato/CreazioneNuovoManuale';
import DettaglioSchedaNuovoManuale from './scenes/controlpanel/manuale_personalizzato/DettaglioSchedaNuovoManuale';
import DettaglioProceduraNuovoManuale from './scenes/controlpanel/manuale_personalizzato/DettaglioProceduraNuovoManuale';
import DownloadPDFPage from './scenes/controlpanel/downloadPDF/DownloadPDFPage.js';
import ModificaTemplate from './scenes/controlpanel/dettaglio_brand/ModificaTemplate.js';
import { useTheme } from '@material-ui/core';
import PageNotFound from './pages/PageNotFound.jsx';
import DettaglioProceduraEsercizio from './scenes/controlpanel/dettaglio_eserciziocommerciale/DettaglioProceduraEsercizio.jsx';
import DettaglioSchedaEsercizio from './scenes/controlpanel/dettaglio_eserciziocommerciale/DettaglioSchedaEsercizio.jsx';

export default function AppMainComponent({ is404 }) {
  const theme = useTheme();

  return (
    <BrowserRouter
      basename={
        theme.path !== 'abbonamenti' &&
        theme.path !== 'esercizio_conferma' &&
        theme.path !== 'download-pdf' &&
        theme.path !== 'reset_password' &&
        theme.path !== 'recover_password'
          ? theme.path
          : ''
      }
    >
      <LastLocationProvider>
        <div className="AppMain">
          {!is404 && <CustomHeader />}
          <div className="AppContent">
            <Switch>
              <Route path="/login" component={LoginPage} />
              <Route path="/abbonamenti" component={PagamentoPage} />
              <Route path="/logout" component={LogoutPage} />
              <Route path="/recover_password" component={RecoverPswPage} />
              <Route path="/reset_password" component={ResetPswPage} />
              <Route
                path="/esercizio_conferma/:activationKey"
                component={WrapperAccettaEsercizio}
              />
              <Route
                path="/conferma_registrazione/:activationKey"
                component={WrapperConfermaRegistrazione}
              />
              <Route
                path="/download-pdf/:revisioneId"
                component={WrapperDownloadPDF}
              />
              <Route
                path="/amministrazione/edit_template/:templateId"
                component={withAuthentication(WrapperModificaTemplate)}
              />
              <Route
                path="/amministrazione/gruppi/:gruppoId/consulenti/nuovo"
                component={withAuthentication(WrapperRegistraConsulenteGruppo)}
              />
              <Route
                path="/amministrazione/gruppi/:gruppoId"
                component={withAuthentication(WrapperDettaglioGruppo)}
              />
              <Route
                path="/amministrazione/brand/:brandId"
                component={withAuthentication(WrapperDettaglioBrand)}
              />
              <Route
                path="/amministrazione/responsabili_sicurezza/:responsabileId"
                component={withAuthentication(
                  WrapperDettaglioResponsabileSicurezza,
                )}
              />
              <Route
                path="/amministrazione/consulenti/:consulenteId"
                component={withAuthentication(WrapperDettaglioConsulente)}
              />
              {/* Le route più specifiche vanno definite prima di quelle più generiche */}
              <Route
                path="/amministrazione/esercizi_commerciali/:esercizioId/procedura/:proceduraId"
                component={withAuthentication(WrapperProceduraEsercizio)}
              />
              <Route
                path="/amministrazione/esercizi_commerciali/:esercizioId/scheda/:schedaId"
                component={withAuthentication(WrapperSchedaEsercizio)}
              />
              <Route
                path="/amministrazione/esercizi_commerciali/:esercizioId"
                component={withAuthentication(
                  WrapperDettaglioEsercizioCommerciale,
                )}
              />
              <Route
                path="/amministrazione/manuali/dettagli/:manualeId"
                component={withAuthentication(WrapperDettaglioRevisioneManuale)}
              />
              <Route
                path="/amministrazione/manuali/nuovomanuale/:manualeId/:mode/:hasChapters"
                component={withAuthentication(WrapperNuovoManualeTest)}
              />
              <Route
                path="/amministrazione/dettaglioProcedura/:proceduraId/:idManuale/:idParagrafo"
                component={withAuthentication(WrapperNuovaProcedura)}
              />
              <Route
                path="/amministrazione/schedaProcedura/:schedaId/:idManuale/:idParagrafo"
                component={withAuthentication(WrapperScheda)}
              />
              <Route
                path="/amministrazione"
                component={withAuthentication(ControlPanel)}
              />
              {/* If none of the previous routes render anything,
            this route acts as a fallback.
            Important: A route with path="/" will *always* match
            the URL because all URLs begin with a /. So that's
            why we put this one last of all */}
              <Route exact path="/" render={() => <HomePage />} />
              <Route path="*" component={PageNotFound} />
            </Switch>
          </div>
        </div>
      </LastLocationProvider>
    </BrowserRouter>
  );
}

function WrapperDownloadPDF() {
  const { revisioneId } = useParams();
  return <DownloadPDFPage revisioneId={revisioneId}></DownloadPDFPage>;
}

function WrapperAccettaEsercizio() {
  let { activationKey } = useParams();
  let theme = useTheme();
  return (
    <AccettaEsercizioCommerciale theme={theme} activationKey={activationKey} />
  );
}

function WrapperConfermaRegistrazione() {
  const { activationKey } = useParams();
  return <ConfermaRegistrazione activationKey={activationKey} />;
}

function WrapperDettaglioGruppo() {
  const { gruppoId } = useParams();
  const theme = useTheme();
  let component =
    gruppoId === 'nuovo' ? (
      <NuovoGruppoPage theme={theme} />
    ) : (
      <ModificaGruppoPage theme={theme} gruppoId={gruppoId} />
    );
  return component;
}

function WrapperRegistraConsulenteGruppo() {
  const { gruppoId } = useParams();
  const theme = useTheme();
  return <RegistraConsulenteGruppoPage gruppoId={gruppoId} theme={theme} />;
}

function WrapperNuovaProcedura() {
  const theme = useTheme();
  const { proceduraId, idManuale, idParagrafo } = useParams();
  return (
    <DettaglioProceduraNuovoManuale
      id={proceduraId}
      idManuale={idManuale}
      idParagrafo={idParagrafo}
      theme={theme}
    />
  );
}

function WrapperScheda() {
  const theme = useTheme();
  const { schedaId, idManuale, idParagrafo } = useParams();
  return (
    <DettaglioSchedaNuovoManuale
      id={schedaId}
      idManuale={idManuale}
      idParagrafo={idParagrafo}
      theme={theme}
    />
  );
}

function WrapperDettaglioResponsabileSicurezza() {
  let history = useHistory();
  let { responsabileId } = useParams();
  const consulenteId =
    getConsulenteId() === null || getConsulenteId() === 'null'
      ? null
      : Number.parseInt(getConsulenteId(), 10);
  const consulenteView = consulenteId !== null;
  const superconsulenteView = isSuperconsulente();
  const gruppoId =
    getGruppoId() === null || getGruppoId() === 'null'
      ? null
      : Number.parseInt(getGruppoId(), 10);
  return (
    <DettaglioResponsabileSicurezza
      responsabileId={responsabileId}
      consulenteId={consulenteId}
      gruppoId={gruppoId}
      consulenteView={consulenteView}
      superconsulenteView={superconsulenteView}
      onClose={() => {
        history.goBack();
      }}
    />
  );
}

function WrapperDettaglioConsulente() {
  let history = useHistory();
  let theme = useTheme();
  let { consulenteId } = useParams();
  const consulenteView =
    getConsulenteId() !== null && getConsulenteId() !== 'null';
  const superconsulenteView = isSuperconsulente();
  const gruppoId =
    getGruppoId() === null || getGruppoId() === 'null'
      ? null
      : Number.parseInt(getGruppoId(), 10);
  return (
    <DettaglioConsulente
      theme={theme}
      consulenteId={consulenteId}
      gruppoId={gruppoId}
      consulenteView={consulenteView}
      superconsulenteView={superconsulenteView}
      onClose={() => {
        history.goBack();
      }}
    />
  );
}

function WrapperDettaglioEsercizioCommerciale() {
  let { esercizioId } = useParams();
  let theme = useTheme();
  let component = null;
  const consulenteId =
    getConsulenteId() === null || getConsulenteId() === 'null'
      ? null
      : Number.parseInt(getConsulenteId(), 10);
  const gruppoId =
    getGruppoId() === null || getGruppoId() === 'null'
      ? null
      : Number.parseInt(getGruppoId(), 10);
  const superconsulenteView = isSuperconsulente();
  if (esercizioId === 'nuovo') {
    component =
      consulenteId !== null ? (
        <NuovoEsercizioConsulente
          consulenteId={consulenteId}
          gruppoId={gruppoId}
          superconsulente={superconsulenteView}
          theme={theme}
        />
      ) : (
        <NuovoEsercizioCommerciale
          theme={theme}
          consulenteId={consulenteId}
          superconsulente={superconsulenteView}
        />
      );
  } else {
    component = (
      <DettaglioEsercizioCommerciale
        esercizioId={esercizioId}
        consulenteId={consulenteId}
        superconsulente={superconsulenteView}
        gruppoId={gruppoId}
        theme={theme}
      />
    );
  }
  return <Fragment>{component}</Fragment>;
}

function WrapperDettaglioRevisioneManuale() {
  const { manualeId } = useParams();
  const theme = useTheme();
  const gruppoId =
    getGruppoId() === null || getGruppoId() === 'null'
      ? null
      : Number.parseInt(getGruppoId(), 10);
  const consulenteId =
    getConsulenteId() === null || getConsulenteId() === 'null'
      ? null
      : Number.parseInt(getConsulenteId(), 10);
  const superconsulenteView = isSuperconsulente();
  return (
    <DettaglioManualeSicurezza
      revisioneManualeId={manualeId}
      gruppoId={gruppoId}
      consulenteId={consulenteId}
      superconsulenteView={superconsulenteView}
      theme={theme}
    />
  );
}

function WrapperNuovoManualeTest() {
  let { manualeId, mode, hasChapters } = useParams();
  let theme = useTheme();
  if (hasChapters === 'true') {
    return (
      //<CreazionePartiNuovoManualeCopy manualeId = {manualeId} mode = {mode}></CreazionePartiNuovoManualeCopy>
      <CreazioneNuovoManuale
        tabValue="Empty"
        manualeId={manualeId}
        mode={mode}
        theme={theme}
      />
    );
  } else {
    return (
      <CreazioneNuovoManuale
        tabValue="Empty"
        manualeId={manualeId}
        mode={mode}
        theme={theme}
      />
    );
  }
}

function WrapperDettaglioBrand() {
  const { brandId } = useParams();
  const theme = useTheme();

  if (brandId === 'nuovo') {
    return <ModificaTemplate mode={'Create'} theme={theme} />;
  } else {
    return null;
  }
}

function WrapperModificaTemplate() {
  const { templateId } = useParams();
  const theme = useTheme();

  return (
    <ModificaTemplate mode={'Update'} templateId={templateId} theme={theme} />
  );
}

function WrapperProceduraEsercizio() {
  const { esercizioId, proceduraId } = useParams();
  return (
    <DettaglioProceduraEsercizio
      key={`${esercizioId}-${proceduraId}`}
      esercizioId={esercizioId}
      proceduraId={proceduraId}
    />
  );
}

function WrapperSchedaEsercizio() {
  const { esercizioId, schedaId } = useParams();
  return (
    <DettaglioSchedaEsercizio esercizioId={esercizioId} schedaId={schedaId} />
  );
}
